export const formWidgetJs: string = `<script>
  function evalHtml(elementId, content) {
      const container = document.getElementById(elementId);
      const wrapper = document.createElement('div');
      wrapper.innerHTML = content;
      wrapper.style.display = 'none';
      container.appendChild(wrapper);
  }

  function evalStyle(elementId, url) {
      const head = document.getElementById(elementId);
      const link = document.createElement('link');
      link.href = url;
      link.rel = 'stylesheet';
      head.insertBefore(link, head.firstChild);
  }

  function evalScript(elementId, url) {
      const head = document.getElementById(elementId);
      const script = document.createElement('script');
      script.src = url;
      head.insertBefore(script, head.firstChild);
  }

  function evalInlineScript(elementId, content) {
      const head = document.getElementById(elementId);
      const script = document.createElement('script');
      script.appendChild(document.createTextNode(content));
      head.insertBefore(script, head.firstChild);
  }

  const currentParams = new URLSearchParams(window.location.search);
  const params  = new URLSearchParams();

  params.set('v', '2');

  const cid = currentParams.get('cid');
  if (cid && !cid.includes('{')) {
    params.set('cid', cid);
  }

/* params */

  fetch(endpoint + params)
  .then((body) => body.json())
  .then((response) => {
    const elementId = 'embedded-head-form';

    if (response.html) {
        document.querySelectorAll('.embedded-form').forEach(el => {
            el.innerHTML = response.html;
        });
    }
    if (response['translations']) evalHtml(elementId, response['translations']);
    if (response['styles']) response.styles.forEach(url => evalStyle(elementId, url));
    if (response['scripts']) response.scripts.forEach(scriptUrl => evalScript(elementId, scriptUrl));
    if (response['inlineScripts']) response['inlineScripts'].forEach(scriptContent => evalInlineScript(elementId, scriptContent));
  })
</script>

<div id="embedded-head-form"></div>`;

export const toolFormatIdJs = `  let tfi = '89de9384';
  const toolFormId = currentParams.get('tfi');
  if (toolFormId && toolFormId !== '{tfi}') {
    tfi = toolFormId;
  }`;
export const endPointJs = `  const endpoint = %endpoint%;`;
export const gridFormatJs = `  params.set('grf', currentParams.get('grf') ?? '%gridFormat%');`;
export const folderSetJs = `  params.set('fset', currentParams.get('fset') ?? '%folderSet%');`;
export const sourceTypeJs = `  params.set('srct', currentParams.get('srct') ?? '%sourceType%');`;
export const sourceDetailJs = `  const sourceDetails = %sourceDetails%;
  for (const sourceDetail of sourceDetails) {
    params.set('srcd[]', sourceDetail);
  }`;
